module.exports = __webpack_public_path__ + "img/pinterest_white.a00a9ec2.svg";